import { Breadcrumbs, Chip, Link, Stack } from "@mui/material";
import HerbImage from "../../assets/doors/4_tzgx.jpeg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { SiteRoutes } from "../../PageRouter";

export const Door4 = () => {
  const ingredients = [
    "Speisesalz",
    "Zwiebeln",
    "Pfeffer",
    "Thymian",
    "Basilikum",
    "Rosmarin",
    "Knoblauch",
  ];

  const doorNr = 4;

  const shortDecription =
    "Spinat schmeckt am besten, wenn man ihn kurz vor dem Verzehr durch ein großes Steak ersetzt.";

  const herbName = "Steak & Grill Gewürzsalz";

  const recepieExample = (
    <div>
      Beliebiges Steak, am besten vom Rind, auf dem Grill (alternativ in der
      Pfanne) zubereiten. Gegrillte Steaks von beiden Seiten mit dem Gewüzsalz
      bestreuen und heiß Servieren
    </div>
  );

  const breadcrumb = (
    <Breadcrumbs maxItems={4} separator={<NavigateNextIcon fontSize="small" />}>
      <Link
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="inherit"
        href="/"
      >
        Start
      </Link>
      {SiteRoutes.map((route) => {
        if (route.doorNumber && route.doorNumber <= doorNr) {
          return (
            <Link
              key={route.path}
              underline="hover"
              color="inherit"
              href={route.path}
            >
              Tag {route.doorNumber}
            </Link>
          );
        } else {
          return undefined;
        }
      })}
    </Breadcrumbs>
  );

  return (
    <>
      <img src={HerbImage} className="herb_img" alt="herb" />
      {breadcrumb}
      <h1 className="herb_name">{herbName}</h1>
      <i>{shortDecription}</i>
      <h3 className="content">Inhalt</h3>
      <div>
        <Stack
          spacing={1}
          direction="row"
          useFlexGap
          flexWrap="wrap"
          justifyContent="center"
        >
          {ingredients.map((ingredient, i) => {
            return (
              <Chip
                key={i}
                style={{ flexGrow: 1 }}
                label={ingredient}
                variant={i % 2 === 0 ? "filled" : "outlined"}
              />
            );
          })}
        </Stack>
      </div>
      <h3>Rezeptidee</h3>
      {recepieExample}
    </>
  );
};
